import React from "react";

export default function PasswordStrengthBar({ password }) {
    let label = "Too short";
    let level = 0;

    const len = password.length;
    const hasLower = /[a-z]/.test(password);
    const hasUpper = /[A-Z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecial = /[@#$&]/.test(password);

    if (len === 0) {
        label = "";
        level = 0;
    } else if (len < 8) {
        label = "Too short (min 8 characters)";
        level = 1;
    } else {
        // len is >= 8, now check other criteria
        let criteriaCount = 0;
        if (hasLower) criteriaCount++;
        if (hasUpper) criteriaCount++;
        if (hasNumber) criteriaCount++;
        if (hasSpecial) criteriaCount++;

        if (criteriaCount < 2) {
            label = "Weak"; level = 2;
        } else if (criteriaCount === 2) {
            label = "Okay"; level = 3;
        } else if (criteriaCount === 3) {
            label = "Good"; level = 4;
        } else if (criteriaCount === 4) {
            label = "Strong"; level = 5;
        }
    }

    const colors = ["#eee", "#ff6b6b", "#ee8641ff", "#ffd24d", "#81cf53ff", "#2ecc71"];

    return (
        <div style={{ marginTop: 10 }}>
            <div style={{ display: "flex", gap: 6, marginBottom: 5 }}>
                {[1, 2, 3, 4, 5].map((i) => (
                    <div
                        key={i}
                        style={{
                            flex: 1,
                            height: 3,
                            borderRadius: 4,
                            backgroundColor: i <= level ? colors[level] : "#eee",
                            transition: "background-color 180ms ease",
                        }}
                    />
                ))}
            </div>
            <span style={{ fontSize: 14, color: "#9b9393ff" }}>{label}</span>
        </div>
    );
}
